export default "__VITE_ASSET__DfrmskC4__"